import { render, staticRenderFns } from "./BdTableList.vue?vue&type=template&id=5e03969c&scoped=true"
import script from "./BdTableList.vue?vue&type=script&lang=js"
export * from "./BdTableList.vue?vue&type=script&lang=js"
import style0 from "./BdTableList.vue?vue&type=style&index=0&id=5e03969c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e03969c",
  null
  
)

export default component.exports